import React from "react";
import "../../css/sharedStyles.css";
import "./CharacterContainer.css";
import {spinningGlobeEffect} from "../includes/spinningGlobeEffect.js";

var CharacterContainer = class CharacterContainer extends React.Component{
    constructor(props) {
        super(props);
        this.fixedDescription;

        this.correctHeadshot;
        this.correctDescription;
        this.correctName;

    }


    componentDidMount(){
        this.correctName = this.props.characterInfo.character;
        this.correctHeadshot = this.props.characterInfo.headShot;
        this.correctDescription = this.props.characterInfo.description; 
    }//end componentDidMount()

    componentDidUpdate(prevProps) {
        this.fixedDescription = this.handleDescription();

        if(prevProps.characterInfo.character != this.props.characterInfo.character){
            //this whole if() setup is to display the correct character info when someone 
            //misspells or enters a name that doesnt exist. 
            //if youre on Hulk and search "dsfasfasd", then itll display Hulk
            
            var prevCharacter = prevProps.characterInfo.character;
            var prevID = prevProps.characterInfo.characterID;
            //console.log("prevCharacter: " + prevCharacter + " prevID: " + prevID);
            
            var newCharacter = this.props.characterInfo.character;

            if(newCharacter === "misspelled"){
                this.correctName = prevProps.characterInfo.character;
                this.correctHeadshot = prevProps.characterInfo.headShot;
                this.correctDescription = prevProps.characterInfo.description;
            }
            else{
                this.correctName = this.props.characterInfo.character;
                this.correctHeadshot = this.props.characterInfo.headShot;
                this.correctDescription = this.props.characterInfo.description;                
            }

        }



    }

    handleDescription(){

        //console.log("correctName: " + this.correctName + " --- correctHeadshot: " + this.correctHeadshot + " --- correctDescription: " +  this.correctDescription);



        var description = this.props.characterInfo.description; 
        var handledDescription = description;
        if(description.indexOf("I was unable to find anything") != -1){
            try{
                this.refs.description.style.color = "#da0000"; //red
                this.refs.mobileDescription.style.color = "#da0000"; //red
            }
            catch(err){/*console.log("description doesnt exist it");*/} 
        }
        else{
            handledDescription = description;
            try{
                this.refs.description.style.color = "#2b98fb"; //jarvis blue
                this.refs.mobileDescription.style.color = "#2b98fb"; //jarvis blue
            }
            catch(err){/*console.log("description doesnt exist it");*/}  
        }
        return handledDescription;
    }



    render(props) {
        
        this.fixedDescription = this.handleDescription();
        
        //determine if we render the characters headshot or the spinning globe effect
        var characterImage = this.correctHeadshot;
        var characterName = this.correctName ;
        var headShot = spinningGlobeEffect(characterImage,characterName);


        return ( 
        <div>
            <div className="characterContainer content_box_topWedge" id="mobileCharacter">
                <div className="MOBILEheadshot">
                    <img src={characterImage} className="MOBILEheadshotImage"/>
                </div>
                
                    <h1 className='MOBILEcharacterName'>{this.correctName}</h1>
                    {/* <div className="MOBILEdescription">{this.props.characterInfo.description}</div> */}
                    <div ref = "mobileDescription" className="MOBILEdescription">{this.correctDescription}</div>
            </div>       
        
        
            <div className="characterContainer" id="desktopCharacter"> 
                <div className="content_box_square imgBoxWidth" id="headShotDesktop">
                    {/* <img src={this.props.characterInfo.headShot} className="characterHeadshot"/> */}
                    {headShot}
                </div>
                <div className="content_box_topWedge textBoxWidth" id="infoDesktop">
                    <h1 className="characterName">{this.correctName}</h1>
                    {/* <p className="characterDescription">{this.props.characterInfo.description}</p> */}
                    <p ref = "description" className="characterDescription">{this.correctDescription}</p>
                </div>
            </div>
        </div>
      );
    }
  }

  export default CharacterContainer;


// WEBPACK FOOTER //
// ./src/components/characterArea/CharacterContainer.js